/* eslint-disable no-nested-ternary */
export const monerisDefault = {
  Port: '10109',
  LogLevel: 'ERROR',
  LogFileName: 'moneris-integration',
  SSLEnable: true,
  SSLKeyPath: 'cert/star_localhost_erply_com.key',
  SSLCertPath: 'cert/star_localhost_erply_com.crt',
  Production: true,
  logSentryDuration: 0,

  ConnectionType: 'ethernet',
  DeviceTimeout: 60,
  TerminalIPAddress: 'terminal_ip_address',
  TerminalPort: '9599',
  Receipt: 'none',
};

export const monerisFields = {
  ConnectionType: {
    id: 'ConnectionType',
    title: 'Connection Type',
    type: 'select',
    options: ['ethernet'],
  },
  DeviceTimeout: {
    id: 'DeviceTimeout',
    title: 'Device timeout',
    type: 'text',
    validate: (val) => (val < 0 ? 'Timeout must be positive' : null),
  },
  TerminalIPAddress: {
    id: 'TerminalIPAddress',
    title: 'Terminal IP address',
    type: 'text',
    validate: (val) =>
      val?.toString().length ? null : 'Terminal IP address is required.',
  },
  TerminalPort: {
    id: 'TerminalPort',
    title: 'Terminal Port',
    type: 'text',
    validate: (val) =>
      val > 0
        ? val >= 1024
          ? null
          : 'Invalid port. Must be equal to or larger than 1024'
        : 'Port must be specified',
  },
  Receipt: {
    id: 'Receipt',
    title: 'Receipt',
    type: 'select',
    options: ['none', 'merchant', 'cardholder', 'merchant, cardholder'],
  },
};
